EMMY.bindEntryDetails = {
  init: function() {

  }
};